import { render, staticRenderFns } from "./WhatMakesUsUnique.vue?vue&type=template&id=2b8c0035&scoped=true&"
import script from "./WhatMakesUsUnique.vue?vue&type=script&lang=js&"
export * from "./WhatMakesUsUnique.vue?vue&type=script&lang=js&"
import style0 from "./WhatMakesUsUnique.vue?vue&type=style&index=0&id=2b8c0035&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b8c0035",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VCol,VImg,VRow,VSheet})
